import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=320cb8ac&scoped=true&"
import script from "./LegalNotice.vue?vue&type=script&lang=js&"
export * from "./LegalNotice.vue?vue&type=script&lang=js&"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=320cb8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320cb8ac",
  null
  
)

export default component.exports